module.exports = __webpack_public_path__ + "images/referenzen/imagefilm/easycredit_kampagnefilm_daguckste.jpg";